/*
 Flagship Config.
 Environment config belongs outside the src folder in config.json.
 */

const services = [
    {
        value: "analytics",
        text: "Analytics"
    },
    {
        value: "blog",
        text: "Blog"
    },
    {
        value: "display",
        text: "Display",
        subOptions: [
            {value: "device-id", text: "Device ID"},
            {value: "ip-targeting", text: "IP Targeting"},
            {value: "microproximity", text: "Microproximity"},
            {value: "mobile-expandable", text: "Mobile Expandable"},
            {value: "native", text: "Native"},
            {value: "outreach-retargeting", text: "Outreach/Retargeting"},
            {value: "foot-traffic-attribution", text: "Foot Traffic Attribution"}
        ]
    },
    {
        value: "email-marketing",
        text: "Email Marketing",
    },
    {
        value: "ott-ctv",
        text: "OTT / CTV",
        subOptions: [
            {value: "generic-ctv", text: "Package 1: Generic Connected TV"},
            {value: "targeted-ctv", text: "Package 2: Targeted Connected TV"},
            {value: "generic-ott", text: "Package 3: Generic Over-the-Top"},
            {value: "targeted-ott", text: "Package 4: Targeted Over-the-Top"}
        ]
    },
    {
        value: "ppc",
        text: "Pay-Per-Click"
    },
    {
        value: "reputation-management",
        text: "Reputation Management"
    },
    {
        value: "seo",
        text: "Search Engine Optimization"
    },
    {
        value: "social-media",
        text: "Social Media",
        subOptions: [
            {value: "social-media-management", text: "Full Social Media Management"},
            {value: "social-media-ads", text: "Social Media Ads Only"},
            {value: "social-media-refresh", text: "Social Media Refresh"},
            {value: "social-media-sweepstakes", text: "Social Media Sweepstakes"},
            {value: "facebook-app", text: "Facebook App"}
        ]
    },
    {
        value: "video",
        text: "Video Production"
    },
    {
        value: "website",
        text: "Website",
        subOptions: [
            {value: "website-redesign", text: "Website Design & Development"},
            {value: "website-landing-page", text: "Landing Page Design"},
            {value: "website-hosting", text: "Web Hosting Renewal"},
        ]
    },
    {
        value: "youtube",
        text: "YouTube"
    }
];

const config = {
    version: '2.0.0 BETA',
    markets: [
        "Cincinnati",
        "Chicago",
        "Phoenix",
        "Seattle",
        "St. Louis",
        "Twin Cities",
        "Washington",
        "Northern MN",
    ],
    records: {
        client: {
            statuses: {
                "prospect": {
                    "label": "Prospect",
                    "color": "green"
                },
                "pending": {
                    "label": "Pending",
                    "color": "blue"
                },
                "closed": {
                    "label": "Closed Business",
                    "color": "yellow"
                },
                "trash": {
                    "label": "No Longer Active",
                    "color": "red"
                }
            },
            defaultStatus: "prospect",
            extra1: {
                type: "text",
                required: true,
                label: "DBS"
            },
            extra2: {
                type: "text",
                multi: true,
                value: [""],
                required: false,
                label: "Account Executive(s)"
            },
            extra3: {
                type: "text",
                label: "Initial Meeting",
                required: false,
                validation: "date"
            }
        },
        rfp: {
            statuses: {
                "draft": {
                    "label": "Draft",
                    "color": "black"
                },
                "publish": {
                    "label": "Needs Pricing",
                    "color": "green"
                },
                "priced": {
                    "label": "Pricing Complete",
                    "color": "blue"
                },
                "proposal": {
                    "label": "Proposal Attached",
                    "color": "purple"
                },
                "closed": {
                    "label": "Closed Business",
                    "color": "yellow"
                },
                "insertion": {
                    "label": "IOs Attached",
                    "color": "orange"
                },
                "trash": {
                    "label": "Canceled",
                    "color": "red"
                }
            },
            defaultStatus: "draft",
            extra1: {
                type: "client",
                validation: "client-name",
                label: "Client",
                required: true,
                placeholder: "Begin typing to select a client..."
            },
            extra2: {
                type: "text",
                required: true,
                label: "DBS"
            },
            extra3: {
                type: "text",
                label: "Due Date",
                required: true,
                validation: "date",
                minDatePadding: 2
            }
        },
        io: {
            statuses: {
                "draft": {
                    "label": "Draft",
                    "color": "black"
                },
                "publish": {
                    "label": "In Progress",
                    "color": "green"
                },
                "needs_materials": {
                    "label": "Needs Materials",
                    "color": "orange"
                },
                "submitted": {
                    "label": "Submitted",
                    "color": "purple"
                },
                "mixed": {
                    "label": "Some Launched",
                    "color": "teal"
                },
                "launched": {
                    "label": "All Launched",
                    "color": "blue"
                },
                "paused": {
                    "label": "All Paused",
                    "color": "yellow"
                },
                "complete": {
                    "label": "All Complete",
                    "color": "grey"
                },
                "trash": {
                    "label": "Canceled",
                    "color": "red"
                }
            },
            ioProductStatuses: {
                "publish": {
                    "label": "New",
                    "color": "green"
                },
                "needs_materials": {
                    "label": "Needs Materials",
                    "color": "orange"
                },
                "submitted": {
                    "label": "Submitted",
                    "color": "purple"
                },
                "launched": {
                    "label": "Launched",
                    "color": "blue"
                },
                "paused": {
                    "label": "Paused",
                    "color": "yellow"
                },
                "complete": {
                    "label": "Complete",
                    "color": "grey"
                },
                "trash": {
                    "label": "Canceled",
                    "color": "red"
                }
            },
            defaultStatus: "draft",
            extra1: {
                type: "rfp",
                validation: "rfp-number",
                label: "RFP",
                required: true,
                placeholder: "Select an RFP..."
            },
            extra2: {
                type: "user",
                label: "Market Contact",
                required: true,
                defaultValue: '',
                validation: "user"
            },
            extra3: {
                type: "text",
                label: "Launch Date",
                required: true,
                validation: "date",
                defaultValue: '',
                minDatePadding: 2
            },
        }
    },
    lineItemServices: services,
    possibleActions: {
        "comment" : "added a comment",
        "change" : "made a change",
        "change-status-io" : "updated an IO status",
        "change-status-rfp" : "triggered an RFP status update",
        "change-business-closed" : "closed business",
        "create-client": "added a Client",
        "create-rfp" : "created an RFP",
        "create-io": "created an IO",
        "create-line-item": "added a line item",
        "update-line-item": "updated a line item",
        "create-io-product": "added an IO product",
        "update-io-product": "updated an IO product",
        "update-io-product-status": "updated an IO product status",
        "file-upload": "uploaded a file",
        "proposal-upload": "uploaded a proposal",
        "update-line-item-pricing": "updated line item pricing",
        "update-io-product-assignment": "updated an IO product assignment"
    }
};

export default config;


// WEBPACK FOOTER //
// ./src/constants/config.js